import $ from 'jquery';
import debounce from '../utility/debounce';
import hub from '../utility/events-hub';

let searchWidget;
let searchToggle;
let searchForm;
let searchFormInput;
let hasSearchHero;
let autoSuggestAPI;
let shoppingCart;
let shoppingCartLink;
let shoppingCartPopup;
let shoppingCartLabel;
let shoppingCartList;
let shoppingCartTotal;
let shoppingCartTotalWithVat;

const addAutoCompleteSuggestions = function ($input) {
    if ($input.length < 1 || $input.attr('data-enableAutoComplete') == 'false') {
        return;
    }
    $input.attr('autocomplete', 'off');

    let cacheVal = '';

    const $inputParent = $input.parent();
    const suggestionWrap = $('<div class="js-ac-wrap"></div>');
    $inputParent.append(suggestionWrap);

    function clearSuggestionList() {
        suggestionWrap.html('');
        $('body').off('click', clearSuggestionList);
    }

    function createSuggestionList(suggestions) {
        const ul = $('<ul>');
        suggestions.forEach(function (suggestion) {
            const li = $('<li><a href="">' + suggestion + '</a></li>');
            li.find('a').on('click', function (e) {
                e.preventDefault();
                $input.val(suggestion);
                $input.siblings('button').trigger('click');
            });
            ul.append(li);
        });
        suggestionWrap.html(ul);
        $('body').on('click', clearSuggestionList);
    }

    function inputHandler() {
        const val = $input.val();
        if (val.length > 0 && val !== cacheVal) {
            cacheVal = val;
            $.get('/api/search/autocomplete/?q=' + val)
                .done(function (data) {
                    if (data.length && data.length > 0) {
                        createSuggestionList(data);
                    } else {
                        clearSuggestionList();
                    }
                })
                .fail(function (error) {
                    console.log(error); // eslint-disable-line no-console
                });
        } else {
            cacheVal = '';
            clearSuggestionList();
        }
    }

    $input.on('keyup', debounce(inputHandler, 300));

    return {
        clearSuggestionList
    };
};

const getCartHtml = function (items) {
    return items.map((product) => {

        return `
            <div class="search-header-cart-item">
                <div class="search-header-cart-item-image"><img src="${!product.imageUrl ? '/Assets/gfx/blank.gif' : product.ImageUrl}"></div>
                <div class="search-header-cart-item-info">
                    <div class="search-header-cart-item-title">${product.ProductName}</div>
                    <div class="search-header-cart-item-description">${product.VariantDisplayName.DisplayNameSlash}</div>
                </div>
                <div class="search-header-cart-item-details">
                    <div class="search-header-cart-item-price">${product.HasDiscountedPrice ? product.LocalizedDiscountPriceWithCurrency : product.LocalizedPlacedPriceWithCurrency}</div>
                    <div class="search-header-cart-item-amount">${product.Quantity} ${product.SalesUnit}</div>
                </div>
            </div>
        `;
    }).join('');
};

const init = function (opts) {

    const defaults = {
        selectors: {
            widget: '.js-search-header',
            toggle: '.js-search-header-toggle',
            form: '.js-search-header-form',
            formInput: '.js-search-header-form-input',
            shoppingCart: '.js-header-cart',
            shoppingCartLink: '.js-header-cart-link',
            shoppingCartPopup: '.js-header-cart-popup',
            shoppingCartLabel: '.js-header-cart-label',
            shoppingCartList: '.js-header-cart-list',
            shoppingCartTotal: '.js-header-cart-total',
            shoppingCartTotalWithVat: '.js-header-cart-total-with-vat',
            hero: '.search-hero',
            msg: '.js-header-cart-msg'
        },
        modifiers: {
            widget: {
                open: 'search--open'
            }
        }
    };

    const options = $.extend(true, defaults, opts);

    searchWidget = $(options.selectors.widget);
    if (searchWidget.length < 1) return;

    hasSearchHero = $(options.selectors.hero).length > 0;
    if (hasSearchHero) {
        searchWidget.remove();
        return;
    }

    searchToggle = $(options.selectors.toggle, searchWidget);
    searchForm = $(options.selectors.form, searchWidget);
    searchFormInput = $(options.selectors.formInput, searchForm);
    shoppingCart = $(options.selectors.shoppingCart, searchWidget);
    shoppingCartLink = $(options.selectors.shoppingCartLink, searchWidget);
    shoppingCartPopup = $(options.selectors.shoppingCartPopup, searchWidget);
    shoppingCartLabel = $(options.selectors.shoppingCartLabel, searchWidget);
    shoppingCartList = $(options.selectors.shoppingCartList, searchWidget);
    shoppingCartTotal = $(options.selectors.shoppingCartTotal, searchWidget);
    shoppingCartTotalWithVat = $(options.selectors.shoppingCartTotalWithVat, searchWidget);

    autoSuggestAPI = addAutoCompleteSuggestions(searchFormInput);

    searchToggle.on('click', function (e) {
        e.preventDefault();
        searchWidget.toggleClass(options.modifiers.widget.open);
        if (searchWidget.hasClass(options.modifiers.widget.open)) {
            searchFormInput.focus();
        } else {
            autoSuggestAPI.clearSuggestionList();
        }
    });

    shoppingCartLink.on('mouseover', () => {
        if (window.innerWidth <= 570) return;

        shoppingCart.addClass('open');
        if (!searchWidget.hasClass('search--open')) {
            searchWidget.addClass('search--collapsed');
        }
    });

    shoppingCartLink.on('mouseleave', () => {
        if (window.innerWidth <= 570) return;

        if ($(`${options.selectors.shoppingCartPopup}:hover`).length !== 0) return;

        shoppingCart.removeClass('open');
        if (!searchWidget.hasClass('search--open')) {
            searchWidget.removeClass('search--collapsed');
        }
    });

    shoppingCartPopup.on('mouseleave', () => {
        if (window.innerWidth <= 570) return;

        shoppingCart.removeClass('open');
        if (!searchWidget.hasClass('search--open')) {
            searchWidget.removeClass('search--collapsed');
        }
    });

    // On cart update

    hub.subscribe(hub.event.shoppingCartUpdate, function (e, data) {
        // console.log('hub.event.shoppingCartUpdate', data);
        const $msg = $(options.selectors.msg);
        shoppingCartList.html(getCartHtml(data.CartItems));
        shoppingCartTotal.text(data.LocalizedTotalWithCurrency);
        shoppingCartLabel.text(data.CartItems.reduce((total, item) => {
            return total + item.Quantity;
        }, 0));

        if (data.IsB2B) {
            shoppingCartTotalWithVat.text(data.LocalizedTotalWithCurrencyWithVat);
            shoppingCartTotalWithVat.parent().removeClass('u-hidden');
        }

        const hasExceededQnt = data.CartItems.filter((product) => {
            return product.Quantity === data.maxQnt;
        });


        if (data.HasRelevantPromotions) {
            if (data.PotentialPromotions.length) {
                let promotionTpl = '';

                data.PotentialPromotions.forEach((item) => {
                    if (!item.IsFulfilled) {
                        if (item.PromotionTypeName === 'SpendAmountForFreeShipping') {
                            promotionTpl += `
                        <div class="alert alert-center alert-orange is-active">
                            ${item.Description && item.Description.replace('##AMOUNT##', item.LocalizedRemainingAmountWithCurrency).replace('##PERCENTAGE##', item.Percentage)}
                        </div>`;

                        } else {
                            promotionTpl += `
                        <div class="alert alert-center alert-green is-active">
                            ${item.Description && item.Description.replace('##AMOUNT##', item.LocalizedRemainingAmountWithCurrency).replace('##PERCENTAGE##', item.Percentage)}
                        </div>`;
                        }
                    }
                });

                $('.js-header-cart-promotions').html(promotionTpl);
            }
        }

        if (hasExceededQnt.length) {
            $msg.show();
        } else {
            $msg.hide();
        }

        if (window.innerWidth < 570) return;
        shoppingCart.addClass('open');
        if (!searchWidget.hasClass('search--open')) {
            searchWidget.addClass('search--collapsed');
        }
        setTimeout(function () {
            shoppingCart.removeClass('open');
            searchWidget.removeClass('search--collapsed');
        }, 5000);
    });
};

export default {
    init
};
